import Axios from "axios";

export const SelectAvoir = (a, b, c, d, e) => {
  return (dispatch) => {
    Axios.get(
      `https://www.24-crm.tn/webservice/api/FACCLIs?typew=A&coddos=${a}&serveur=${b}&user=${c}&pwd=${d}&database=${e}`
    ).then((response) => {
      return dispatch({ type: "AVOIR_SELECT", payload: response.data });
    });
  };
};
